import Vue from 'vue'
import VueScrollableTabs from 'vue-scrollable-tabs'

Vue.use(VueScrollableTabs)
